import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { DialogConfirmComponent } from 'src/app/shared/components/dialog-confirm/dialog-confirm.component';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { CustomerBranchDialogComponent } from '../customer-branch-dialog/customer-branch-dialog.component';
import {
  branchStatusLabel,
  CustomerBranch,
  filterBranches,
  isMatrizBranch,
  removeBranch,
  upsertBranch,
} from '../customer-branch.util';

@Component({
  selector: 'app-customer-branches-panel',
  templateUrl: './customer-branches-panel.component.html',
  styleUrls: ['./customer-branches-panel.component.sass'],
})
export class CustomerBranchesPanelComponent {
  @Input() branches: CustomerBranch[] = [];
  @Input() typeCes: TypeCesEnum = TypeCesEnum.EDIT;
  @Output() branchesChange = new EventEmitter<CustomerBranch[]>();

  searchTerm = '';
  readonly displayedColumns = ['title', 'document', 'city', 'status', 'actions'];

  constructor(private dialog: MatDialog) {}

  get readonly(): boolean {
    return this.typeCes === TypeCesEnum.SHOW;
  }

  get rows(): CustomerBranch[] {
    return filterBranches(this.branches, this.searchTerm);
  }

  status(branch: CustomerBranch): string {
    return branchStatusLabel(branch);
  }

  isMatriz(branch: CustomerBranch): boolean {
    return isMatrizBranch(branch);
  }

  open(branch?: CustomerBranch, viewMode = false): void {
    const index = branch ? this.branches.findIndex((item) => item.localKey === branch.localKey) : -1;
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: CustomerBranchDialogComponent,
      data: { branch: branch || null, index, viewMode: viewMode || this.readonly },
      dialogConfig: { width: '920px', maxWidth: '95vw' },
      callBack: (result?: { branch: CustomerBranch; index: number }) => {
        if (!result?.branch || viewMode || this.readonly) return;
        this.branchesChange.emit(upsertBranch(this.branches, result.branch, result.index));
      },
    });
  }

  remove(branch: CustomerBranch): void {
    const index = this.branches.findIndex((item) => item.localKey === branch.localKey);
    if (this.readonly || index <= 0 || isMatrizBranch(branch)) return;
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
        title: 'Confirmação',
        content: `Deseja remover a filial "${branch.branchTitle}"?`,
        yesText: 'Sim, remover',
        noText: 'Cancelar',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result?.result === true) {
        this.branchesChange.emit(removeBranch(this.branches, index));
      }
    });
  }
}
